import $ from 'jquery'
import memoize from 'lodash/memoize'

import * as Model from 'api/model'

/**
 * Pozi MDL Drawer Adapter for info tab
 */
const PoziDrawerTabTools = memoize(function () {
  // Adapters
  const adapters = {
    init: function () {
      return init()
    }
  }

  /**
   * Init
   */
  var init = function () {
    const bToolsEnabled = Model.get('config.layout.drawer.tabs.tools.enabled', true)
    if (!bToolsEnabled) {
      $('.toolButtons').hide()
    }

    const bLoginVisible = Model.get('config.layout.drawer.tabs.tools.login.visible', false)
    const loginType = Model.get('config.layout.drawer.tabs.tools.login.type', '')

    if (bLoginVisible && loginType !== 'aws') {
      $('#login-div').show()
      $('#login-div').on('click', function () {
        if (loginType === 'aws') {
          $('#manual-login').hide()
          $('#login-div-info').removeClass('tool-button-wrapper-info')
          $('#aws-amplify').show()
        } else {
          $('#aws-amplify').hide()
          $('#manual-login').show()
        }
      })
    } else {
      // $('#login-div').hide() // Hidden by default in CSS
    }
  }

  // Return adapters (must be at end of adapter)
  return adapters
})

export default PoziDrawerTabTools
